import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

interface Props {
  name?: string | null
}


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'ChipIcon'
},
  __name: 'ChipIcon',
  props: {
    name: { default: null }
  },
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  const _component_VIcon = _resolveComponent("VIcon")!

  return (_openBlock(), _createBlock(_component_VIcon, {
    size: "1.25rem",
    class: "p-0.25",
    icon: __props.name
  }, null, 8, ["icon"]))
}
}

})